import { SocialPost } from "../collaborations";
import { CampaignPermalink } from "../permalinks";

export interface ContentLibraryResponse {
    items: LibraryItem[],
    count: number
}

export interface LibraryItem {
    payments_sum_amount: string,
    campaign: {
        uuid: string,
        name: string
    },
    ig_post: {
        id: number,
        like_count: number,
        comments_count: number,
        views_count: number,
        posted_on: string,
        ig_account: {
            username: string
        },
        thumbnail_url: string,
        influencer_uuid?: string,
        permalink: string
    },
    social_post: SocialPost & {
        social_account: {
            handle: string
        }
    },
}

export interface ContentLibraryFilters {
    page: number,
    campaign_id?: {
        uuid: string,
        name?: string
    },
    posted_on?: string,
    [key: string]: any
}

export interface ContentLibrarySlice {
    error: string | null,
    loading: boolean,
    total: number,
    filtered_lists: Record<string, {
        count: number,
        list: LibraryItem[],
        page: number,
        has_more: boolean,
        last_fetched_at: number,
        filters: any,
        expired: boolean
    }>,
    applied_filter_id: string | null,
    filters: ContentLibraryFilters,
}

export const defaultContentLibraryFilters = {
    page: 1,
}

